module.exports = __webpack_public_path__ + "static/media/W_Calendar_07.d07bdb69.png";